import { render, staticRenderFns } from "./SearchableList.vue?vue&type=template&id=54838966"
import script from "./SearchableList.vue?vue&type=script&lang=js"
export * from "./SearchableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports